import { client } from '../http';

export default {
  async askCashflowAssistant(sessionId, currentInput) {
    const response = await client.post(
      '/api/ask-cashflow-assistant',
      { sessionId, currentInput },
    );
    return response.data;
  },

  async getConversations() {
    const response = await client.post('/api/chat-conversations');
    return response.data;
  },

  async getConversationMessages(conversationId) {
    const response = await client.post('/api/chat-conversation-messages', { conversationId });
    return response.data;
  },

  async deleteConversation(conversationId) {
    const response = await client.post('/api/chat-delete-conversation', { conversationId });
    return response.data;
  },

  async escalateConversation(conversationId) {
    const response = await client.post('/api/escalate-conversation', { conversationId });
    return response.data;
  },
};
